import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20amber%20stage%20curtains%20dramatic%20lighting%20rays%20elegant%20dark%20background%20with%20subtle%20lens%20flares%20professional%20photography%20style%20clean%20artistic%20composition%20no%20text&width=1600&height=900&seq=hero-bg-777&orientation=landscape"
        alt="777影院 - 影视导航入口"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl w-full">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
            777<span className="text-primary-500">影院</span>官网
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-2">
            7777影院 · 777777影院 · 77777影院 · 7777777影院 统一入口
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto">
            免费观看高清电影和电视剧全集，快速进入官方首页
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dongzuo"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg"></i>
              开始观影
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full font-medium text-sm border border-white/20 hover:bg-white/20 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            {['7777影院', '777777影院', '77777影院', '7777777影院'].map((v) => (
              <span
                key={v}
                className="px-3 py-1.5 bg-white/10 backdrop-blur-sm text-white/80 text-xs rounded-full border border-white/10 whitespace-nowrap"
              >
                {v}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}